import React, { useEffect, useState, useRef } from "react";
import * as FeatherIcon from "react-feather";
import "./FeedbackSuggestions.css";
import SimpleThemedButton from "../../../../genericComponents/simpleTextField/SimpleThemedButton";

export default function FeedbackSuggestions({
  setPrompt,
  handleUpdateEmail,
  btnDisabled,
}) {
  const [value, setValue] = useState("");
  const [isListening, setIsListening] = useState(false);
  const [voiceSupported, setVoiceSupported] = useState(false);
  const recognitionRef = useRef(null);

  useEffect(() => {
    // ✅ Detect Chrome's Web Speech API
    if ("webkitSpeechRecognition" in window) {
      const recognition = new window.webkitSpeechRecognition();
      recognition.continuous = false;
      recognition.interimResults = false;
      recognition.lang = "en-US";
      recognitionRef.current = recognition;
      setVoiceSupported(true);

      recognition.onresult = (event) => {
        const transcript = event.results[0][0].transcript;
        setValue((prev) => (prev ? prev + " " + transcript : transcript));
      };

      recognition.onerror = (err) => {
        console.error("Speech recognition error:", err);
        setIsListening(false);
      };

      recognition.onend = () => setIsListening(false);
    }
  }, []);

  const handleVoiceToggle = () => {
    if (!recognitionRef.current) return;
    if (isListening) {
      recognitionRef.current.stop();
      setIsListening(false);
    } else {
      recognitionRef.current.start();
      setIsListening(true);
    }
  };

  const handleSend = async () => {
    if (btnDisabled) return;
    const trimmed = value.trim();
    if (!trimmed) return;
    setPrompt(trimmed);
    setValue("");
    await handleUpdateEmail(trimmed);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="ai-input-wrapper darkblue-theme">
      <div className="ai-header">
        <span style={{display:"flex",justifyContent:"flex-start",alignItems:"center"}}>
         <FeatherIcon.Zap className="ai-logo"/> <span >Improve email with AI</span> 
        </span>
        {/* <span className="ai-header-right">Powered by GPT-5</span> */}
      </div>

      <div className="ai-input-container">
        <textarea
          className="ai-input"
          placeholder={"Give AI additional context or instructions " }
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={handleKeyDown}
          rows={1}
        />

        <div className="ai-input-actions">
          {voiceSupported && (
            <div className="ai-voice-wrapper">
              <button
                className={`ai-icon-btn ${isListening ? "listening" : ""}`}
                onClick={handleVoiceToggle}
                title={isListening ? "Stop voice input" : "Start voice input"}
              >
                <FeatherIcon.Mic size={16} />
              </button>

              {isListening && (
                <div className="ai-voice-anim">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <span key={i} className="bar" />
                  ))}
                </div>
              )}
            </div>
          )}

      
          <SimpleThemedButton btnDisabled={btnDisabled} buttonText={<>
            <FeatherIcon.ArrowUp size={15} /></>} onBtnClick={handleSend}/>
        </div>
      </div>
    </div>
  );
}
 